var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightTakeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5421_6108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35417 14.2767C5.48449 14.3445 5.62508 14.3697 5.7642 14.3502L8.91793 13.9307C9.8164 13.7684 10.7033 13.5078 11.5698 13.1516C11.7295 13.0956 11.887 13.0289 12.0417 12.9518L18.1244 9.95542C19.0444 9.57178 19.8836 8.90453 20.574 8.00775C21.4355 6.74925 20.7238 6.32975 20.7238 6.32975C20.3226 6.10799 19.8921 5.9959 19.4578 6.00015C19.0409 5.99564 18.627 6.09384 18.2368 6.2898L15.3677 7.68813C15.04 7.85024 14.6862 7.895 14.3415 7.81798L7.49463 6.30978C7.05028 6.20909 6.59402 6.26065 6.16872 6.4596L5.03008 6.98897L10.139 10.1752L6.97026 11.6734C6.7133 11.8127 6.42568 11.8127 6.16872 11.6734L3.9214 10.3649L3 10.8743L5.01509 13.9606C5.10758 14.1006 5.22385 14.2089 5.35417 14.2767ZM2.83333 18.95H21.1667C21.3877 18.95 21.5996 19.0554 21.7559 19.2429C21.9122 19.4304 22 19.6848 22 19.95C22 20.2152 21.9122 20.4696 21.7559 20.6571C21.5996 20.8447 21.3877 20.95 21.1667 20.95H2.83333C2.61232 20.95 2.40036 20.8447 2.24408 20.6571C2.0878 20.4696 2 20.2152 2 19.95C2 19.6848 2.0878 19.4304 2.24408 19.2429C2.40036 19.0554 2.61232 18.95 2.83333 18.95Z",
    fill: "#7E8A96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5421_6108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightTakeOff);
export default __webpack_public_path__ + "static/media/flightTakeOff.34adb8b7.svg";
export { ForwardRef as ReactComponent };